function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.1886 20.4063H1.18947C1.5286 20.7463 2.07731 20.748 2.41731 20.408C3.04515 19.7811 7.65739 15.1671 7.95218 14.8723C9.99134 12.8331 11.0453 12.3357 11.7931 12.2818C12.5862 12.2244 13.3392 11.941 13.9018 11.3783C17.2793 8.00089 21.8576 2.9356 19.635 0.730347C19.5402 0.806 13.9679 6.37826 1.19121 19.1741C0.852071 19.5132 0.849462 20.0672 1.1886 20.4063V20.4063Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.80469 2.03442L5.71779 5.94753",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 4.20837L3.85744 7.77712C4.41397 8.33365 5.1679 8.60496 5.95313 8.66148C6.46357 8.69888 7.12619 8.95714 8.13751 9.75715",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.52572 8.36671C8.63527 7.23973 8.41961 6.54842 8.4257 6.01276C8.43353 5.33362 8.1457 4.68665 7.66482 4.20664L3.63867 0.795288",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4707 13.9309L19.0152 20.4754C19.3552 20.8154 19.9056 20.8154 20.2447 20.4754C20.5847 20.1362 20.5847 19.5858 20.2447 19.2458L14.269 13.2692",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoResturants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResturants);
export default __webpack_public_path__ + "static/media/ico-resturants.8c31206e.svg";
export { ForwardRef as ReactComponent };